import { DateTime } from "luxon"

export class Company {
    id: number
    code: string
    type: string

    constructor(id: number, code:string, type:string) {
        this.id = id
        this.code = code
        this.type = type
    }

    clone(): Company {
        return new Company(this.id, this.code, this.type);
    }
}

export interface ICompanyRepository {
    find_by_type_and_code(user_id:number, code:string, cdb_type:string): Promise<Company|undefined>;
}

export function getLinkErrors(company_links): Array<Array<String>> {
    let errors = []
    for (const link of company_links) {
        let link_errors: String[] = []
        if (!link.deleted) {

            let min_date = link.min_date
            let max_date = link.max_date
            let start_ejercicio = link.start_ejercicio
            let end_ejercicio = link.end_ejercicio
            let year_ejercicio = String(link.year_ejercicio)

            // wrong ranges not allowed
            if (min_date && max_date) {
                if (min_date > max_date) link_errors.push('range_date')
            }
            else {
                if (!min_date) link_errors.push('min_date')
                if (!max_date) link_errors.push('max_date')
            }
            
            if (start_ejercicio && end_ejercicio) {
                if (start_ejercicio > end_ejercicio) link_errors.push('range_ejercicio')
            }
            else {
                if (!start_ejercicio) link_errors.push('start_ejercicio')
                if (!end_ejercicio) link_errors.push('end_ejercicio')
            }
            
            // invoice dates outside ejercicio dates not allowed
            if (start_ejercicio && min_date < start_ejercicio) link_errors.push('min_date')
            if (end_ejercicio && max_date > end_ejercicio) link_errors.push('max_date')

            if (start_ejercicio && end_ejercicio) {
                let start_year = start_ejercicio.split('-')[0]
                let end_year = end_ejercicio.split('-')[0]

                if (start_year != year_ejercicio && end_year != year_ejercicio) {
                    link_errors.push('year_ejercicio')
                    if (ejercicio_editable(link)) {
                        link_errors.push('start_ejercicio')
                        link_errors.push('end_ejercicio')
                    }
                }
            }

            // same year between ejercicios not allowed
            if (link.year_ejercicio) {
                for (const other_link of company_links) {
                    if (link.id != other_link.id && !other_link.deleted && year_ejercicio == String(other_link.year_ejercicio))
                        link_errors.push('year_ejercicio')
                }
            }
            else link_errors.push('year_ejercicio')

            // overlap between ejercicios (min/max date & start/end ejercicio)
            for (const other_link of company_links) {
                if (link.id != other_link.id && !other_link.deleted) {
                    
                    const other_min_date = other_link.min_date
                    const other_max_date = other_link.max_date

                    // check if dates are inside the range of the other link
                    if (other_min_date <= min_date && min_date <= other_max_date)
                        link_errors.push('min_date')
                    if (other_min_date <= max_date && max_date <= other_max_date)
                        link_errors.push('max_date')

                    const other_start_ejercicio = other_link.start_ejercicio
                    const other_end_ejercicio = other_link.end_ejercicio

                    // same with start/end ejercicio dates
                    if (other_start_ejercicio <= start_ejercicio && start_ejercicio <= other_end_ejercicio)
                        link_errors.push('start_ejercicio')
                    if (other_start_ejercicio <= end_ejercicio && end_ejercicio <= other_end_ejercicio)
                        link_errors.push('end_ejercicio')
                }
            }

        }
        errors.push(link_errors)
    }
    return errors
}

export function ejercicio_editable(link) {
    if (link.id) {
        return ejercicio_year_diff(link) != 1
    }
    else return true
}

export function ejercicio_year_diff(link): number {
    const ini = DateTime.fromISO(link.start_ejercicio);
    const end = DateTime.fromISO(link.end_ejercicio).plus({ days: 1 });
    const diffYear = end.diff(ini, 'years').years;
    return diffYear
}

export function hasAnyError(all_links_errors: Array<Array<String>>) {
    let any_error = false
    for (const link_error of all_links_errors) {
        if (link_error.length != 0) {
            any_error = true
            break
        }
    }
    return any_error
}


// CONTANET Ids check
export const contanet_id_attribute_names = [
    'supplier_id_contanet','customer_id_contanet',
    'vat_no_deductible_supplier_id_contanet','vat_no_deductible_customer_id_contanet',
    'intra_supplier_id_contanet','intra_customer_id_contanet',
    'extra_supplier_id_contanet','extra_customer_id_contanet',
    'isp_supplier_id_contanet','isp_customer_id_contanet'
]

export function isEmptyOrContanetId(text: string) { // Only digits 0-9
    if (text == null || text === '') return true
    let numIdRegex = /^[0-9A-Z]?[0-9]$/ // 1-2 characters: if 2, first one can be an uppercase letter
    return numIdRegex.test(text)
}

// SAGE DESPACHOS Ids check - must be integers only
export const sage_despachos_id_attribute_names = [
    'supplier_id_contanet', 'customer_id_contanet', //IVA y IGIC
    'vat_no_deductible_supplier_id_contanet', 'vat_no_deductible_customer_id_contanet',
    'intra_supplier_id_contanet', 'intra_customer_id_contanet',
    'extra_supplier_id_contanet', 'extra_customer_id_contanet',
    'isp_supplier_id_contanet', 'isp_customer_id_contanet'
]

export function isEmptyOrSageIntegerId(text: string) {
    if (text == null || text === '') return true
    let integerRegex = /^[0-9]+$/ // Only digits, no decimals or letters
    return integerRegex.test(text)
}